import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Media from 'components/common/Media'
import { InputField } from 'components/common/FormElements/Input'
import Button from 'components/common/Button/Button'
import Banner from 'components/common/Banner/Banner'
import { normalizePhoneNumber } from 'helpers/phone-number'
import * as UI from '../Shared.styles'
import { formatAddress, FormatAddress } from './helpers'
import { PHONE_MASK } from 'constant'
import { BIRTHDAY_HINT_ID } from './constants'

const PersonalInformationForm = ({
  onCancel,
  error,
  submitFailed,
  handleSubmit,
  model,
  normalizeValue,
  setFocusScopeRef,
  handleOptionsFetch,
  handleChooseAddressSuggestion
}) =>
  <form noValidate onSubmit={ handleSubmit }>
    {
      submitFailed && error &&
      <CustomBanner error_alternative>
        { error }
      </CustomBanner>
    }
    <UI.Col ref={ setFocusScopeRef }>
      <InputField { ...model.firstName } full static />
    </UI.Col>
    <UI.Col>
      <InputField { ...model.lastName } full static />
    </UI.Col>
    <UI.Col large clear>
      <InputField
        { ...model.addressLine1 }
        full
        static
        getSuggestionValue={ formatAddress }
        formatSuggestion={ FormatAddress }
        onChooseSuggestion={ handleChooseAddressSuggestion }
        onFetchSuggestions={ handleOptionsFetch } />
    </UI.Col>
    <UI.Col large clear>
      <InputField { ...model.addressLine2 } full static />
    </UI.Col>

    <UI.Col clear>
      <InputField { ...model.city } full static />
    </UI.Col>
    <UI.Col short data-at-accountdetails-personal-info-form-state>
      <InputField { ...model.state } full static normalize={ normalizeValue } />
    </UI.Col>
    <UI.Col short>
      <InputField { ...model.zipCode } full static />
    </UI.Col>

    <UI.Col clear>
      <InputField { ...model.cellPhoneNumber } mask={ PHONE_MASK } full static normalize={ normalizePhoneNumber } />
    </UI.Col>
    <UI.Col>
      <InputField { ...model.otherPhoneNumber } mask={ PHONE_MASK } full static normalize={ normalizePhoneNumber } />
    </UI.Col>

    <UI.Col monthsTitle clear padding="0 0 15px">
      <Strong>Birthday</Strong> <Comment optional>(optional)</Comment>
    </UI.Col>
    <UI.Col monthsInput data-at-accountdetails-personal-info-form-birthmonth>
      <InputField { ...model.month } full static normalize={ normalizeValue } />
    </UI.Col>
    <UI.Col short data-at-accountdetails-personal-info-form-birthday>
      <InputField { ...model.day } full static normalize={ normalizeValue } />
    </UI.Col>
    <UI.Col auto padding="0 0 15px">
      <Comment id={ BIRTHDAY_HINT_ID } last>Tell us your birthday and we will send you a treat!</Comment>
    </UI.Col>

    <UI.Buttons>
      <Button data-at-accountdetails-personal-info-form-save>Save</Button>
      <Button link data-at-accountdetails-personal-info-form-cancel onClick={ onCancel }>Cancel</Button>
    </UI.Buttons>
  </form>

PersonalInformationForm.propTypes = {
  error: PropTypes.string,
  fetchAddresses: PropTypes.func,
  handleChooseAddressSuggestion: PropTypes.func,
  handleOptionsFetch: PropTypes.func,
  handleSubmit: PropTypes.func,
  model: PropTypes.shape({
    addressLine1: PropTypes.shape(),
    addressLine2: PropTypes.shape(),
    cellPhoneNumber: PropTypes.shape(),
    city: PropTypes.shape(),
    day: PropTypes.shape(),
    firstName: PropTypes.shape(),
    otherPhoneNumber: PropTypes.shape(),
    lastName: PropTypes.shape(),
    month: PropTypes.shape(),
    state: PropTypes.shape(),
    zipCode: PropTypes.shape()
  }),
  normalizeValue: PropTypes.func,
  onCancel: PropTypes.func,
  onFetchSuggestions: PropTypes.func,
  setFocusScopeRef: PropTypes.func,
  submitFailed: PropTypes.bool
}

export default PersonalInformationForm

const Strong = styled.span`
  font-weight: 600;
`

const Comment = styled.span`
  display: inline-block;
  font-size: 12px;
  ${Media.desktop`
    margin-top: 11px;
  `}
  ${props => props.optional && css`
    font-style: italic;
  `}
  ${props => props.small && css`
    font-size: 10px;
  `}
  ${props => props.last && css`
    ${Media.desktop`
      margin-left: -14px;
    `}
  `}
`

const CustomBanner = styled(Banner)`
  padding-top: 0;
  margin-bottom: 25px;
`
